import analiticaInstance from '@/vendor/analitica.vendor'

/**
 * @typedef {import('@stone-payments/analitica').EventFactory} EventFactory
 * @description This is the event that will be sent to the Amplitude plugin
 * @description import Amplitude from '@amplitude/sidemenu.amplitude'
 * @example Amplitude.events.actions.exportDataClicked()
 * @description
 * @example context: { filters: {}, viewed: {loadView: () => ({})}, actions: {} }
 */

const sideMenuEvents = analiticaInstance?.eventFactory('Sidemenu', {
  actions: {
    menuItemClicked: (menuItem) => ({
      label: 'cta clicked - pagarme dash',
      metadata: {
        url: window.location.href,
        section_reference: 'menu',
        link_reference: menuItem
      }
    })
  }
})

export default sideMenuEvents
